import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorAlertDialogComponent } from '@components/dialogs/error-alert-dialog/error-alert-dialog.component';
import { resolveMessageVars } from '@helpers/resolve-message-vars.helper';
import { HandledExceptionI } from '@interfaces/handled-exception.interface';
import { ErrorDialogDataI } from '@interfaces/error-dialog-data.interface';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {
  constructor(private readonly dialog: MatDialog, private readonly injector: Injector) {}
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        const handledError: HandledExceptionI | undefined = error?.error;

        if (
          handledError?.messageKey &&
          !handledError?.skipInterceptor &&
          error?.status !== HttpStatusCode.Unauthorized
        ) {
          const translate = this.injector.get(TranslateService);
          const resolvedVars = resolveMessageVars(translate, handledError.messageVars);

          if (handledError.toast) {
            const toaster = this.injector.get(ToastrService);
            const message = translate.instant(handledError.messageKey, resolvedVars);

            handledError.toast === 'warning' ? toaster.warning(message) : toaster.error(message);
          } else {
            void this.alertError(handledError, resolvedVars);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private async alertError(error: HandledExceptionI, resolvedVars?: Record<string, any>) {
    const baseData: ErrorDialogDataI = {
      message: error.messageKey,
      messageVars: resolvedVars,
    };

    const data: ErrorDialogDataI = error?.stackTrace
      ? {
          ...baseData,
          stackTrace: JSON.stringify(
            error?.stackTrace?.map((line) => line.replace(/\\/g, '/')),
            null,
            2
          ),
        }
      : baseData;
    this.dialog.open(ErrorAlertDialogComponent, {
      width: '400px',
      data,
      ...(error?.stackTrace ? { width: '1000px', height: '500px' } : {}),
    });
  }
}
